import { RingFinishEnum } from '@jouzen/ecom-components/v3/enums/ringFinish';

import { RingStyleEnum } from '../enums/RingStyleEnum';

export const RING_FINISHES = Object.values(RingFinishEnum);

export const RING_STYLES = Object.values(RingStyleEnum);
